import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { CheckCircle2, Circle, X, Rocket, Gift } from "lucide-react";

function RewardBanner({ amount, onClose }) {
  return (
    <section className="mb-8 rounded-2xl border border-emerald-400/40 bg-emerald-500/10 p-5 flex items-center gap-4 rise" data-testid="checklist-reward-banner">
      <span className="w-12 h-12 rounded-xl bg-emerald-400/20 flex items-center justify-center shrink-0"><Gift className="w-6 h-6 text-emerald-300" /></span>
      <div className="flex-1 min-w-0"><p className="font-semibold text-emerald-200">Checklist complete — ${amount} ride credit added!</p><p className="text-xs text-emerald-300/80 mt-0.5">It applies automatically at your next checkout.</p></div>
      <Link to="/browse" className="text-xs font-semibold text-emerald-200 hover:underline hidden sm:block" data-testid="checklist-reward-browse">Use it →</Link>
      <button onClick={onClose} className="text-emerald-300/70 hover:text-emerald-100" aria-label="Dismiss" data-testid="checklist-reward-close"><X className="w-4 h-4" /></button>
    </section>
  );
}

export default function GettingStarted({ onReward }) {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/me/checklist").then((r) => { setData(r.data); if (r.data.reward_just_granted) onReward?.(); }).catch(() => setData(false)); }, [onReward]);
  if (!data || !data.account_type) return null;
  if (data.complete && data.reward_granted_at && !data.reward_seen) {
    return <RewardBanner amount={data.reward_amount} onClose={async () => { setData({ ...data, reward_seen: true }); try { await api.post("/me/checklist/reward-seen"); } catch { /* ignore */ } }} />;
  }
  if (data.dismissed || data.complete) return null;
  const dismiss = async () => { setData({ ...data, dismissed: true }); try { await api.post("/me/checklist/dismiss"); } catch { /* ignore */ } };
  const pct = Math.round((100 * data.done) / data.total);
  return (
    <section className="mb-8 rounded-2xl border border-blue-500/30 bg-[#0a1120] p-5 rise" data-testid="getting-started">
      <div className="flex items-start justify-between gap-3 mb-3">
        <div><p className="font-semibold inline-flex items-center gap-2"><Rocket className="w-4 h-4 text-blue-300" />Getting started</p><p className="text-xs text-slate-400 mt-0.5" data-testid="getting-started-progress">{data.done} of {data.total} done · <span className="text-emerald-300">finish all for a ${data.reward_amount} ride credit</span></p></div>
        <button onClick={dismiss} className="text-slate-500 hover:text-slate-200" aria-label="Dismiss checklist" data-testid="getting-started-dismiss"><X className="w-4 h-4" /></button>
      </div>
      <div className="h-1.5 rounded-full bg-slate-800 mb-4 overflow-hidden"><div className="h-full bg-blue-400 transition-[width] duration-500" style={{ width: `${pct}%` }} /></div>
      <ul className="grid sm:grid-cols-2 gap-2">
        {data.items.map((i) => (
          <li key={i.key} data-testid={`checklist-${i.key}`} data-done={i.done}>
            <Link to={i.to} className={`flex items-center gap-2.5 rounded-xl border px-3 py-2.5 text-sm transition-colors ${i.done ? "border-emerald-500/30 bg-emerald-500/5 text-slate-400 line-through" : "border-slate-800 bg-[#0d1424] hover:border-blue-500/50"}`}>
              {i.done ? <CheckCircle2 className="w-4 h-4 text-emerald-400 shrink-0" /> : <Circle className="w-4 h-4 text-slate-600 shrink-0" />}{i.label}
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
